import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import CorpProxy from './CorpProxy'

class CorpService extends ServiceBase {
  postLiquidityAndSolvencyAndCoverAge(params) {
    return this.getData(() =>
      CorpProxy.postLiquidityAndSolvencyAndCoverAge(params),
    )
  }
  downloadLiquidityAndSolvencyAndCoverAge(params) {
    return this.getFileDownload(() =>
      CorpProxy.downloadLiquiditySolvencyCoverage(params),
    )
  }
  postAssetManagementEfficiency(params) {
    return this.getData(() => CorpProxy.postAssetManagementEfficiency(params))
  }
  downloadAssetManagementEfficiency(params) {
    return this.getFileDownload(() =>
      CorpProxy.downloadAssetManagementEfficiency(params),
    )
  }
  postProfitability(params) {
    return this.getData(() => CorpProxy.postProfitability(params))
  }
  downloadProfitability(params) {
    return this.getFileDownload(() => CorpProxy.downloadProfitability(params))
  }
  postBusinessGrowth(params) {
    return this.getData(() => CorpProxy.postBusinessGrowth(params))
  }
  downloadBusinessGrowth(params) {
    return this.getFileDownload(() => CorpProxy.downloadBusinessGrowth(params))
  }
}

export default new CorpService()
